import { SignIn } from "@clerk/clerk-react";

const SignInPage = (): JSX.Element => {
  return <SignIn path="/sign-in" />;
};

export default SignInPage;
